import { getExportDownloadUrl } from '../../../../api/historyApi'
import { formatFileSize, formatHistoryDate } from '../../utils/historyHelpers'
import { useAppSelector } from '../../../../store/hooks'
import { historySelector } from '../../../../store/slices/history'

export function useHistoryExportsList() {
    const exports = useAppSelector(historySelector.exports)
    const exportsLoading = useAppSelector(historySelector.exportsLoading)
    const exportsError = useAppSelector(historySelector.exportsError)

    const handleDownloadExport = (item) => {
        const url = getExportDownloadUrl(item.key)
        const link = document.createElement('a')
        link.href = url
        link.download = item.filename || 'export.xlsx'
        document.body.appendChild(link)
        link.click()
        link.remove()
    }

    return {
        exports,
        exportsLoading,
        exportsError,
        formatDate: formatHistoryDate,
        formatSize: formatFileSize,
        handleDownloadExport,
    }
}
